import React from 'react';
import BackupForm from '../../components/backup/BackupForm';

const CreateBackupPage = () => {
  return (
    <div>
      <BackupForm />
    </div>
  );
};

export default CreateBackupPage;